<template>
  <div id="unavailability-date-list">
    <h3> {{ unavailabilityDatePeriodTitle }} </h3>
    <candidate-planning-table-row
      v-for="unavailabilityDate in unavailabilityDates"
      :key="unavailabilityDate.id"
      :unavailabilityDate="unavailabilityDate"
      @showContractColumn="showContractColumn"
      :show-hub="showHub" />
  </div>
</template>

<script type="text/javascript">
import CandidatePlanningTableRow from './CandidatePlanningTableRow'
import moment from 'moment-timezone'

export default {
  name: 'CandidatePlanningTable',
  props: ['start_at', 'end_at', 'unavailabilityDates'],
  data() {
    return {
      isContractColumn: false,
    }
  },
  components: {
    CandidatePlanningTableRow,
  },
  computed: {
    unavailabilityDatePeriodTitle(){
      if (this.start_at == this.end_at) {
        let date = moment(this.start_at, this.$i18n.t('format.date')).locale('fr').format(this.$i18n.t('format.pretty_date'));
        return (date);
      }
      let start = moment(this.start_at, this.$i18n.t('format.date')).locale('fr').format(this.$i18n.t('format.pretty_date'));
      let end = moment(this.end_at, this.$i18n.t('format.date')).locale('fr').format(this.$i18n.t('format.pretty_date'));
      return (this.$i18n.t('CandidatePlanning.from_to', { start: start, end: end }));
    },
    withOfferProvider() {
      return this.unavailabilityDates.filter((unavailability) => unavailability.provider == 'offer');
    },
    hasOfferProviders() {
      return this.withOfferProvider.length > 0;
    },
    hasRealHubs() {
      return this.withOfferProvider.filter((unavailability) => {
        return (unavailability.offer &&
                unavailability.offer.hub &&
                !unavailability.offer.hub.is_fake);
      }).length > 0;
    },
    showHub() {
      return this.hasOfferProviders && this.hasRealHubs
    }
  },
  methods: {
    showContractColumn(isContract) {
      this.isContractColumn = isContract
    }
  }
}
</script>

<style scoped lang="scss">
  @media (max-width: 767px) {
    #unavailability-date-list {
      width: 96%;
      max-width: 96%;
    }
  }
  #unavailability-date-list {
    padding-left: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/CandidatePlanningTable.vue